// src/modules/app-views/_apps/appmulti/orders/pages/Init/actions/menuButton.js
// *******************************************************************************
// MENU BUTTON — Orders list has no parametrization (disabled).
// *******************************************************************************
const ordersInitMenuButton = () => ({
  action: 'dropdownMenu',
  dropdownItems: [],
});

export default ordersInitMenuButton;
